module.exports = __webpack_public_path__ + "img/c6_m.74aeca0d.png";